<template>
  <b-modal id="add_file_modal" ref="add_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type file being uploaded for -->
        <h1>
          <i class="fas fa-file-upload"></i>
          <span v-if="$store.state.files.type === 'company'">Upload Client File(s)</span>
          <span v-else-if="$store.state.files.type === 'contact'">Upload Contact File(s)</span>
          <span v-else-if="$store.state.files.type === 'order'">Upload Order File(s)</span>
          <span v-else-if="$store.state.files.type === 'worker'">Upload Worker File(s)</span>
        </h1>
        <p id="mh-info">Upload File(s) for {{ $store.state.files.name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="addFileForm" slim>
      <form role="form" @submit.prevent="upload_file()">
        <div class="row">
          <div class="col-12 text-center"><h4 class="mb-3">MAX FILESIZE LESS THAN 2MB</h4></div>
          <div class="col-12">
            <hr class="mt-1 mb-3">
          </div>
        </div>

        <!-- Worker File inputs -->
        <div v-if="$store.state.files.type === 'worker'" class="row">
          <div class="col-12">

            <div v-if="!$store.state.files.uploaded_files.includes('id_1')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>ID 1</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_id_1_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.id_1" :hidden_id="'worker_id_1_file'"></file_input>
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('id_2')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>ID 2</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_id_2_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.id_2" :hidden_id="'worker_id_2_file'"></file_input>
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('id_1') || !$store.state.files.uploaded_files.includes('id_2')" class="row">
              <div class="col-12">
                <hr class="mt-1 mb-3">
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('contract')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>Contract</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_contract_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.contract" :hidden_id="'worker_contract_file'"></file_input>
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('application')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>Application Form</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_application_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.application" :hidden_id="'worker_application_file'"></file_input>
              </div>
            </div>
            <div v-if="$store.state.files.employment_type === 'Sole Trader' || $store.state.files.employment_type === 'Limited'">
              <div v-if="!$store.state.files.uploaded_files.includes('pe_ins_cert') || !$store.state.files.uploaded_files.includes('pi_ins_cert')" class="row">
                <div class="col-12">
                  <hr class="mt-1 mb-3">
                </div>
              </div>
              <div v-if="!$store.state.files.uploaded_files.includes('pe_ins_cert')" class="row form-group">
                <div class="col-4"><label class="upload_label" style="line-height: 17.5px;"><strong>P.E. Insurance Certificate</strong></label></div>
                <div class="col-8">
                  <file_input @file-chosen="worker_pe_ins_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                              :selected_file="worker_files.pe_ins_cert" :hidden_id="'worker_pe_ins_file'"></file_input>
                </div>
              </div>
              <div v-if="!$store.state.files.uploaded_files.includes('pi_ins_cert')" class="row form-group">
                <div class="col-4"><label class="upload_label" style="line-height: 17.5px;"><strong>P.I. Insurance Certificate</strong></label></div>
                <div class="col-8">
                  <file_input @file-chosen="worker_pi_ins_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                              :selected_file="worker_files.pi_ins_cert" :hidden_id="'worker_pi_ins_file'"></file_input>
                </div>
              </div>
            </div>
            <div v-if="$store.state.files.vat_registered === true">
              <div v-if="!$store.state.files.uploaded_files.includes('vat_cert')" class="row">
                <div class="col-12">
                  <hr class="mt-1 mb-3">
                </div>
              </div>
              <div v-if="!$store.state.files.uploaded_files.includes('vat_cert')" class="row form-group">
                <div class="col-4"><label class="upload_label"><strong>VAT Certificate</strong></label></div>
                <div class="col-8">
                  <file_input @file-chosen="worker_vat_cert_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                              :selected_file="worker_files.vat_cert" :hidden_id="'worker_vat_cert_file'"></file_input>
                </div>
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('other_1') || !$store.state.files.uploaded_files.includes('other_2')" class="row">
              <div class="col-12">
                <hr class="mt-1 mb-3">
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('other_1')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>Other 1</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_other_1_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.other_1" :hidden_id="'worker_other_1_file'"></file_input>
              </div>
            </div>
            <div v-if="!$store.state.files.uploaded_files.includes('other_2')" class="row form-group">
              <div class="col-4"><label class="upload_label"><strong>Other 2</strong></label></div>
              <div class="col-8">
                <file_input @file-chosen="worker_other_2_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                            :selected_file="worker_files.other_2" :hidden_id="'worker_other_2_file'"></file_input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr class="mt-1 mb-3">
              </div>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="float-right">
              <button type="submit" class="btn orcaBtn">UPLOAD and CLOSE</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import file_input from 'partials/files/fileInput';

export default {
  name: "add_file",
  components: {file_input},
  data() {
    return {
      file: {
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },
      worker_files: {
        id_1: null,
        id_2: null,
        contract: null,
        application: null,
        vat_cert: null,
        pe_ins_cert: null,
        pi_ins_cert: null,
        other_1: null,
        other_2: null
      }
    }
  },
  methods: {
    hideModal() {
      this.$refs.add_file_modal.hide();
      this.$store.commit('HIDE_FILE_MODAL');
    },
    /**
     * WORKER FILE FUNCTIONS
     */
    worker_id_1_file(file) {
      this.worker_files.id_1 = file;
    },
    worker_id_2_file(file) {
      this.worker_files.id_2 = file;
    },
    worker_contract_file(file) {
      this.worker_files.contract = file;
    },
    worker_application_file(file) {
      this.worker_files.application = file;
    },
    worker_other_1_file(file) {
      this.worker_files.other_1 = file;
    },
    worker_other_2_file(file) {
      this.worker_files.other_2 = file;
    },
    worker_pe_ins_file(file) {
      this.worker_files.pe_ins_cert = file;
    },
    worker_pi_ins_file(file) {
      this.worker_files.pi_ins_cert = file;
    },
    worker_vat_cert_file(file) {
      this.worker_files.vat_cert = file;
    },
    /**
     * UPLOAD FILE FUNCTION
     */
    upload_file() {
      // check the type the file upload is relevant to (client/contact/order/worker)
      if (this.$store.state.files.type === 'worker') {
        let worker_files = [];
        // loop through each of the possible files a worker could have uploaded
        for (const [key, value] of Object.entries(this.worker_files)) {
          if (value !== null) {
            let type_id = '';
            if (key === 'id_1') { type_id = 6 }
            if (key === 'id_2') { type_id = 7 }
            if (key === 'contract') { type_id = 8 }
            if (key === 'application') { type_id = 9 }
            if (key === 'vat_cert') { type_id = 12 }
            if (key === 'pe_ins_cert') { type_id = 10 }
            if (key === 'pi_ins_cert') { type_id = 11 }
            if (key === 'other_1') { type_id = 13 }
            if (key === 'other_2') { type_id = 14 }

            let worker_file = new FormData();
            let file_name = key + '-' + this.$moment().utc().format('DDMMYYHHmmss') + '.' + /[^.]*$/.exec(this.worker_files[key].name.replace(/ /g, "-"))[0];
            worker_file.append('worker_id', this.$store.state.files.id);
            worker_file.append('belongs_to_type', 'App\\Models\\Workers\\Worker');
            worker_file.append('belongs_to_id', this.$store.state.files.id);
            // worker_file.append('log_by_type', this.file.log_by_type);
            // worker_file.append('log_by_id', this.file.log_by_id);
            worker_file.append('file_master_type_id', type_id);
            worker_file.append('file_name', file_name);
            worker_file.append('file_path', 'storage/worker_files/files/' + this.$store.state.files.id + '/' + file_name);
            worker_file.append('uploaded_file', this.worker_files[key]);
            worker_file.append('log_by_type', 'App\\Models\\Users\\User');
            worker_file.append('log_by_id', this.$store.state.auth.me.id);
            // add to be uploaded file array
            worker_files.push(worker_file);
          }
        }

        // loop through files to be uploaded array and upload
        let upload_amount = worker_files.length;
        for (let file of worker_files) {
          axios.post(this.crmApiPath + 'file', file, {headers: {'Content-Type': 'application/json'}}).then(() => {
            // if last file uploaded then fire reload and close modal
            if (!--upload_amount) {
              this.$snotify.success('Files Uploaded');
              this.$bus.$emit('file::reload', {type: 'worker', action: true});
              this.$bus.$emit('logs::reload', {type: 'worker', action: true});
              this.$nextTick(() => this.hideModal());
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.idInfo {
  font-size: 0.75rem;
}

.upload_label {
  line-height:   36px;
  margin-bottom: 0;
}
</style>
